// extracted by mini-css-extract-plugin
module.exports = {"container":"homeowners-widget_container__e4dwG","imgContainer":"homeowners-widget_imgContainer__Kvmnq"};